import { GET, POST } from "../http"

export const GetMenus = spec => {
    return GET("SharedServices/MenuDataService/GetMenus", spec)
}

export const GetLogs = spec => {
    return GET("SharedServices/Control/Log/GetTraceLog", spec)
}

export const GetReports = spec=>{
    return GET("SharedServices/Control/Report/GetReports", spec)
}
export const GetNationalities = spec=>{
    return GET("SharedServices/NationalityDataService/GetNationalities", spec)
}
export const GetLanguages = spec=>{
    return GET("SharedServices/LanguageDataService/GetLanguages", spec)
}

export const GetTemplates = spec=>{
    return GET("SharedServices/Control/Template/GetTemplates", spec)
}
export const GetDefaultTemplateBySpecification = spec=>{
    return GET("SharedServices/DefaultTemplateHotel/GetDefaultTemplates",spec)
}
export const GetCountries = spec=>{
    return GET("SharedServices/CountryDataService/GetCountries", spec)
}

export const GetStates = spec=>{
    return GET("SharedServices/StateDataService/GetStates", spec)
}

export const CheckGuestTaxExcemptionEligibility = spec=>{
    return POST("SharedServices/Nationality/CheckGuestTaxExcemptionEligibility", spec)
}

export const GetTaxExcemptionEligibilityHistory = spec=>{
    return GET("SharedServices/Nationality/GetTaxExcemptionEligibilityHistory", spec)
}

export const GetNotes = spec=>{
    return GET("SharedServices/Notes/GetNotes", spec)
}
